export const getFaqData = (store) => store.FaqForm.editData;
